import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";
import { Auth0ProviderWithNavigate } from "./auth0-provider-with-navigate";
import { PostHogAnalyticsProvider } from "./posthog-provider";
import { UsageProvider } from "./contexts/UsageContext";
import "./styles/styles.css";

const container = document.getElementById("root") as HTMLElement;

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <PostHogAnalyticsProvider>
        <Auth0ProviderWithNavigate>
          <UsageProvider>
            <App />
          </UsageProvider>
        </Auth0ProviderWithNavigate>
      </PostHogAnalyticsProvider>
    </BrowserRouter>
  </React.StrictMode>
);
